import React, { PureComponent } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';

const range = (start, end) =>
  Array.from({ length: end - start }, (v, k) => k + start);

export default class PaginationComponent extends PureComponent {
  static propTypes = {
    totalItems: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired
  };

  handleClick(e, page) {
    e.preventDefault();
    this.props.onChangePage(page);
  }

  render() {
    const { currentPage, totalItems, pageSize } = this.props;
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // create an array of pages to ng-repeat in the pager control
    const pages = range(startPage, endPage + 1);

    return (
      <div className="pagination__wrap">
        {!pages || pages.length <= 1 ? (
          ''
        ) : (
          <Pagination className="pagination">
            <PaginationItem
              className="pagination__item"
              disabled={currentPage === 1}
            >
              <PaginationLink
                className="pagination__link pagination__caret"
                href="#"
                onClick={e => this.handleClick(e, 1)}
              >
                <i className="fa fa-caret-left" aria-hidden="true" />
              </PaginationLink>
            </PaginationItem>
            {pages.map((page, index) => (
              <PaginationItem
                className="pagination__item"
                key={index}
                active={currentPage === page}
              >
                <PaginationLink
                  className="pagination__link"
                  href="#"
                  onClick={e => this.handleClick(e, page)}
                >
                  {page}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem
              className="pagination__item"
              disabled={currentPage === totalPages}
            >
              <PaginationLink
                className="pagination__link pagination__caret"
                href="#"
                onClick={e => this.handleClick(e, totalPages)}
              >
                <i className="fa fa-caret-right" aria-hidden="true" />
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        )}
        <div className="pagination-info">
          <span>
            Showing{' '}
            {totalItems
              ? pageSize * (currentPage - 1) +
                1 +
                ' to ' +
                (pageSize * currentPage > totalItems
                  ? totalItems
                  : pageSize * currentPage) +
                ' of '
              : ''}
            {totalItems} entries
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.js